import React, { useEffect, useState } from "react";
import { DUCK_PORTRAIT } from "./cityAssets";

export function useTypewriter(text, speed = 14) {
  const [out, setOut] = useState("");
  useEffect(() => {
    setOut("");
    if (!text) return;
    let i = 0;
    const id = setInterval(() => { i += 2; setOut(text.slice(0, i)); if (i >= text.length) clearInterval(id); }, speed);
    return () => clearInterval(id);
  }, [text, speed]);
  return { out, done: out.length >= (text?.length || 0) };
}

export default function CityDialogue({ title, text, speaker = "DUCKY", portrait, children, onClose, testid, tone = "cyan" }) {
  const { out, done } = useTypewriter(text);
  const border = tone === "amber" ? "border-amber-300/70 shadow-[0_0_50px_rgba(251,191,36,0.25)]" : tone === "npc" ? "border-emerald-300/70 shadow-[0_0_50px_rgba(52,211,153,0.25)]" : "border-violet-400/70 shadow-[0_0_50px_rgba(139,92,246,0.35)]";
  return (
    <div className="absolute inset-0 z-30 flex items-end justify-center p-2 sm:p-5 pointer-events-none" data-testid="city-panel">
      <div
        className={`cq-dialogue-in pointer-events-auto relative w-full max-w-4xl border-2 ${border} bg-[#0b0a1f]/95 p-3 sm:p-5 flex gap-3 sm:gap-5 max-h-[70vh]`}
        onClick={(e) => e.stopPropagation()}
        data-testid={testid}
      >
        <div className="absolute inset-0 pointer-events-none cq-scanlines opacity-25" />
        <div className="shrink-0 flex flex-col items-center gap-2">
          <div className="w-16 h-16 sm:w-24 sm:h-24 border-2 border-violet-300/60 bg-[#151233] grid place-items-center overflow-hidden" data-testid="city-dialogue-portrait">
            <img src={portrait || DUCK_PORTRAIT} alt={speaker} className="w-[88%] h-[88%] object-contain cq-portrait-bob" draggable={false} />
          </div>
          <span className="cq-px text-[7px] sm:text-[8px] text-violet-200 bg-violet-500/20 border border-violet-300/40 px-2 py-1">{speaker}</span>
        </div>
        <div className="min-w-0 flex-1 overflow-y-auto pr-14 sm:pr-16">
          {title && <p className="cq-px text-cyan-300 text-[10px] sm:text-sm leading-snug">{title}</p>}
          <p className="mt-2 text-[13px] sm:text-[15px] leading-relaxed text-slate-100 font-mono whitespace-pre-wrap" data-testid="city-dialogue-text">
            {out}{!done && <span className="cq-blink">▌</span>}
          </p>
          {done && <div className="mt-3">{children}</div>}
        </div>
        <button onClick={onClose} className="cq-px absolute top-2 right-2 text-[8px] text-slate-400 hover:text-white px-2 py-1" data-testid="city-panel-close" aria-label="Close">
          ESC ✕
        </button>
      </div>
    </div>
  );
}
